// extracted by mini-css-extract-plugin
export default {"button":"_1ypL0lunsXspVhgPiNM2ZX","menuIcon":"_37Y8z1Lcldb46d8YcinmVm","overlay":"_3EZ667ySf1tBFaQ4FkW26v"};